export const CatMutations = {};

export default {};
